export const SEARCH_VERSION = {
  TWO: '2',
  THREE: '3',
};

export const CATEGORY_SUGGESTION_START_INDEX = 9;
export const SEARCH_PAGE_COR_ID_COOKIE_KEY = 'S_COR_ID';

export const CORE_SITE_DOMAIN = 'https://afterpay.com';

export const CORRELATION_ID_HEADER_KEY = 'correlation-id';
export const REQUEST_ID_STORE_KEY = 'req-id';

type NamedResults = Array<{ name: string }>;
export const filterByName = (results: NamedResults, userInput: string): NamedResults => {
  return results?.filter((obj) => obj?.name.toLowerCase().includes(userInput.toLowerCase()));
};
